import { Injectable, inject } from '@angular/core';
import { Observable, map, of, switchMap } from 'rxjs';

import { GamesName } from '../../shared/constants/games-name.enum';
import { Theme } from '../models/responses/theme';
import { GamesService } from './requests/games';

/**
 * Catálogo de temas do "Quem Sou Eu?". Compartilhado entre as telas de escolha
 * de tema de cada modo (Modo Solo, Desafio Diário), que só diferem no que fazem
 * após a escolha.
 */
@Injectable({ providedIn: 'root' })
export class ThemeCatalogService {
  private readonly gamesService = inject(GamesService);

  loadQuemSouEu(): Observable<Theme[]> {
    return this.gamesService.getAll().pipe(
      map((games) => games.find((game) => game.slug === GamesName.QuemSouEu)?.id ?? null),
      switchMap((idGame) => (idGame ? this.gamesService.getThemes(idGame) : of([]))),
    );
  }
}
